import _ from 'lodash';
//import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { withStyles } from '@material-ui/core/styles';

import moment from 'moment';
import BulkInvoiceContainer from '../../containers/accounting/BulkInvoice';
import pfLogo from '../../images/pearsonFuelsLogoV2.png';

function addCommas(number) {
	return number.toLocaleString();
}

const styles = () => {
	const p = (v) => {
		return `${v * 100}%`;
	};
	const pBlue = '#0790CB';
	const lineColor = '#D9D9D9';
	const rowLineColor = '#f1f1f1';

	return {
		root: {
			position: 'absolute',
			backgroundColor: 'white',
			height: '100%',
			width: '100%',
		},
		container: {
			position: 'relative',
			height: '100%',
			width: '100%',
			padding: `${p(0.065)} ${p(0.075)}`,
			boxSizing: 'border-box',
			fontFamily: 'Roboto',
			color: '#666',
			fontSize: '1.8vw',
		},
		containerWrapper: {
			position: 'relative',
			height: '100%',
			width: '100%',
			//border : '1px solid red',
		},

		logo: {
			marginTop: p(0.02),
			width: p(0.52),
			//height : p(0.),
		},

		formulaName: {
			fontSize: '90%',
			fontWeight: 900,
		},
		formulaUpdated: {
			fontWeight: 300,
			color: '#555',
		},
		formulaTitle: {
			textTransform: 'uppercase',
			color: '#999',
			paddingBottom: 10,
		},
		formulaRow: {
			display: 'flex',
			flexDirection: 'row',
			paddingBottom: 2,
		},
		formulaTotal: {
			borderTop: '2px solid #ccc',
			paddingTop: '5px',
			marginTop: '5px',
			display: 'flex',
			flexDirection: 'row',
			fontWeight: '800',
			paddingBottom: '15px',
		},
		formulaSubtotal: {
			marginLeft: '10%',
			marginRight: '10%',
			borderTop: '1px solid #ddd',
			paddingTop: '5px',
			marginTop: '5px',
			paddingBottom: '15px',
			display: 'flex',
			flexDirection: 'row',
			fontWeight: '800',
		},
		bigInvoiceContainer: {
			marginTop: '9%',
			borderTop: `1px solid ${lineColor}`,
			borderBottom: `1px solid ${lineColor}`,
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			padding: '1% 0%',
			lineHeight: '1.4',
		},
		bigInvoice: {
			fontSize: '4vw',
			fontWeight: 100,
			color: pBlue,
			flexBasis: '50%',
		},
		billingInfo: {
			textAlign: 'left',
			marginRight: '3%',
			flexBasis: '55%',
		},
		label: {
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
		},
		itemSection: {
			marginTop: '12%',
			width: '70%',
			marginLeft: '15%',
			fontSize: '100%',
		},
		labelLine: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderBottom: `1px solid ${lineColor}`,
			paddingBottom: '.4vw',
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
			textTransform: 'uppercase',
		},
		colDescription: {
			flexBasis: '30%',
			textAlign: 'left',
		},
		colQuantity: {
			flexBasis: '70%',
			textAlign: 'right',
		},
		itemRow: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${rowLineColor}`,
			paddingTop: '.9vw',
			paddingBottom: '.9vw',
			//letterSpacing : '.1em',

			paddingRight: '1vw',
			paddingLeft: '1vw',
		},
		rowSubTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${lineColor}`,
			paddingTop: '.9vw',
			paddingBottom: '.9vw',
			//letterSpacing : '.1em',
			fontWeight: 900,
			marginBottom: '2vw',

			paddingRight: '1vw',
			paddingLeft: '1vw',
		},
		rowTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
			borderTop: `1px solid ${pBlue}`,
			paddingTop: '1.5vw',
			paddingBottom: '1.5vw',
			//letterSpacing : '.1em',
			fontWeight: 900,
			marginBottom: '2vw',
			fontSize: '110%',
			backgroundColor: '#f8f8f8',
			paddingRight: '1vw',
			paddingLeft: '1vw',
		},
		miniTotalSection: {
			display: 'flex',
			flexDirection: 'row',
			textAlign: 'right',
			justifyContent: 'flex-end',
			marginTop: '3%',
		},
		poInfo: {
			marginTop: '6%',
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			alignItems: 'center',
			textAlign: 'left',
		},
		poGroup: {
			flexGrow: 1,
			marginRight: '6%',
			'&:last-child': {
				marginRight: '0%',
			},
		},
		poLabel: {
			fontWeight: 600,
			color: '#111',
			letterSpacing: '.1em',
			borderBottom: `1px solid ${lineColor}`,
			paddingBottom: '.4vw',
			textTransform: 'uppercase',
			marginBottom: '.5vw',
		},

		formulaLabel: {
			color: '#333',
			flexBasis: '50%',
			textAlign: 'right',
			paddingRight: '8px',
		},
		formulaValue: {
			color: '#666',
			flexBasis: '50%',
			textAlign: 'left',
		},

		bottomSection: {
			position: 'absolute',
			bottom: '0%',
			width: '100%',
			marginBottom: '2%',
		},

		termAndTotal: {
			display: 'flex',
			flexDirection: 'row',
			justifyContent: 'space-between',
			marginTop: '.8%',
		},
		termParagraph: {
			fontSize: '92%',
			color: '#999999',
			textAlign: 'left',
			fontWeight: 200,
			flexBasis: '100%',
		},
		ourInfoContainer: {
			textAlign: 'center',
			marginTop: '2vw',
		},
	};
};

class BulkLcfsTransfer extends Component {
	constructor(props) {
		super(props);
		const bulkInvoiceId = _.get(this.props, ['match', 'params', 'bulkInvoiceId']);
		const securityHash = _.get(this.props, ['match', 'params', 'securityHash']);

		this.state = {
			bulkInvoiceId: bulkInvoiceId ? parseInt(bulkInvoiceId, 10) : undefined,
			securityHash,
			errors: [],
		};
	}

	componentDidMount() {
		//- Only used for updates
		const { publicGetBulkInvoice, bulkInvoice } = this.props;
		const { bulkInvoiceId, securityHash } = this.state;
		if (bulkInvoice) {
			return;
		}

		publicGetBulkInvoice({
			params: {
				bulkInvoiceId,
				securityHash,
				includeQuickbooksCustomers: true,
				includeQuickbooksTerms: true,
			},
		});
	}

	render() {
		const { classes, bulkInvoice } = this.props;

		if (!bulkInvoice) {
			return <div>Fetching bulk invoice...</div>;
		}

		const { pickupNetGallons, deliveryDate } = bulkInvoice;
		const isLcfsTransfer = false;
		if (isLcfsTransfer) {
			return (
				<div>
					<div style={{ padding: 20 }}>
						<strong>ERROR</strong> : LCFS transfer not implemented for any suppliers.{' '}
						{bulkInvoice.bulkCustomerId}
					</div>
				</div>
			);
		}

		return (
			<div className={classes.root}>
				<div className={classes.container}>
					<div className={classes.containerWrapper}>
						<img alt="Logo" className={classes.logo} src={pfLogo} />

						<div className={classes.ourInfoContainer}>
							<div className={classes.ourInfo}>RTC Fuels, LLC EPA #3344</div>
							<div className={classes.ourInfo}>1360 Rosecrans St. Suite A</div>
							<div className={classes.ourInfo}>San Diego, CA 92106</div>
							<div className={classes.ourInfo}>EIN # 46-0503109</div>
						</div>

						<div className={classes.bigInvoiceContainer}>
							<div className={classes.bigInvoice}>LCFS TRANSFER</div>
							<div className={classes.billingInfo}>
								<div className={classes.formulaName}>Sold To:</div>
								<div className={classes.formulaUpdated}>River City Petroleum Inc</div>
								<div className={classes.formulaUpdated}>3775 N Freeway Blvd Ste 101</div>
								<div className={classes.formulaUpdated}>Sacramento, CA 95834</div>
							</div>
						</div>

						<div className={classes.itemSection}>
							<div className={classes.labelLine}>
								<div className={classes.colDescription}>DESCRIPTION</div>
								<div className={classes.colQuantity}>VALUE</div>
							</div>

							{[
								{ label: 'Fuel Pathway Code', value: 'Ethanol from Corn ETH009A01740101' },
								{ label: 'CI Score', value: '65.55' },
								{ label: 'Application', value: 'LDV/MDV' },
								{ label: 'Transaction Type', value: 'Sold with Obligation' },
								{ label: 'Transaction Date', value: moment(deliveryDate).format('MMMM Do, YYYY') },
								{ label: 'Amount', value: `${addCommas(pickupNetGallons)} gallons` },
								{ label: 'EPA Company ID', value: '3516' },
								{ label: 'EPA Facility ID', value: '70230' },
							].map(({ label, value }) => {
								return (
									<div key={`fr${label}`}>
										<div className={classes.itemRow}>
											<div className={classes.colDescription}>{label}</div>
											<div className={classes.colQuantity}>{value}</div>
										</div>
									</div>
								);
							})}
						</div>
					</div>
				</div>
			</div>
		);
	}
}

BulkLcfsTransfer.propTypes = {
	classes: PropTypes.object.isRequired,
	showErrors: PropTypes.func,

	//- Batch
	publicGetBulkInvoice: PropTypes.func,
	bulkInvoice: PropTypes.object,
	bulkQuotedPriceMap: PropTypes.object,
	bulkFormulaMap: PropTypes.object,
	dataDumpMap: PropTypes.object,
};

export default _.flow([withStyles(styles), BulkInvoiceContainer])(BulkLcfsTransfer);
